// lib/api/admin.ts
import axiosInstance from './axios';
import { API_ENDPOINTS } from './config';
import { ApiError } from './error';
import {
    AdminCreateType,
    AdminUpdateType,
    AdminResponseType,
    PageResponse,
    UserIdCheckResponseType
} from '@/types';

/**
 * 관리자 목록 조회
 */
export async function getAdminListApi(
    page = 0,
    size = 10
): Promise<PageResponse<AdminResponseType>> {
    try {
        // axiosInstance interceptor가 response.data를 반환하므로
        // 여기서 받는 값은 이미 data임
        const data = await axiosInstance.get<PageResponse<AdminResponseType>>(
            API_ENDPOINTS.ADMIN.LIST,
            {
                params: { page, size }
            }
        );
        return data;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 관리자 검색
 */
export async function searchAdminsApi(
    keyword: string,
    page = 0,
    size = 10
): Promise<PageResponse<AdminResponseType>> {
    try {
        const data = await axiosInstance.get<PageResponse<AdminResponseType>>(
            API_ENDPOINTS.ADMIN.SEARCH,
            {
                params: { keyword, page, size }
            }
        );
        return data;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 관리자 상세 조회
 */
export async function getAdminDetailApi(adminId: number): Promise<AdminResponseType> {
    try {
        const data = await axiosInstance.get<AdminResponseType>(
            API_ENDPOINTS.ADMIN.DETAIL(adminId)
        );
        return data;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 관리자 등록
 */
export async function createAdminApi(adminData: AdminCreateType): Promise<AdminResponseType> {
    try {
        const data = await axiosInstance.post<AdminResponseType>(
            API_ENDPOINTS.ADMIN.CREATE,
            adminData
        );
        return data;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 관리자 수정
 */
export async function updateAdminApi(
    adminId: number,
    adminData: AdminUpdateType
): Promise<AdminResponseType> {
    try {
        const data = await axiosInstance.put<AdminResponseType>(
            API_ENDPOINTS.ADMIN.UPDATE(adminId),
            adminData
        );
        return data;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 관리자 삭제 (비활성화)
 */
export async function deleteAdminApi(adminId: number): Promise<void> {
    try {
        await axiosInstance.delete(API_ENDPOINTS.ADMIN.DELETE(adminId));
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 아이디 중복 체크
 */
export async function checkUserIdApi(userId: string): Promise<UserIdCheckResponseType> {
    try {
        const data = await axiosInstance.get<UserIdCheckResponseType>(
            API_ENDPOINTS.ADMIN.CHECK_ID,
            {
                params: { userId }
            }
        );
        return data;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}